import { InjectionToken } from '@angular/core';
import {
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { FieldType, FilterType } from '@ideapa/common-interfaces';

export const ENTITY = 'documento-partecipata';

export const ENTITY_PLURAL = 'Documenti';

export const gridColumns: EntityListField[] = [
  {
    elementLabel: 'Tipo Documento',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'tipologiaDocumento.descrizione',
  },
  {
    elementLabel: 'File',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'filename',
  },
  {
    elementLabel: 'Oggetto',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'oggetto',
  },
  {
    elementLabel: 'Valido dal',
    filterType: FilterType.date,
    fieldType: FieldType.date,
    field: 'validoDal',
  },
  {
    elementLabel: 'Valido al',
    filterType: FilterType.date,
    fieldType: FieldType.date,
    field: 'validoAl',
  },
  {
    elementLabel: 'Data Documento',
    filterType: FilterType.date,
    fieldType: FieldType.date,
    field: 'dataDocumento',
  },
];

export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
